var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWaterTowerWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 33,
    viewBox: "0 0 31 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 15.5C4 14.9477 4.44772 14.5 5 14.5H18C18.5523 14.5 19 14.9477 19 15.5V19C19 19.5523 18.5523 20 18 20H14.5C13.9477 20 13.5 20.4477 13.5 21V31C13.5 31.5523 13.0523 32 12.5 32H12H11C10.4477 32 10 31.5523 10 31V21C10 20.4477 9.55228 20 9 20H5C4.44772 20 4 19.5523 4 19V15.5Z",
    fill: "#2486FD",
    fillOpacity: 0.2,
    stroke: "#1070CA",
    strokeOpacity: 0.2,
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 12C3.5 11.4477 3.94772 11 4.5 11H18.5C19.0523 11 19.5 11.4477 19.5 12V19.5C19.5 20.0523 19.0523 20.5 18.5 20.5H15C14.4477 20.5 14 20.9477 14 21.5V31.5C14 32.0523 13.5523 32.5 13 32.5H10.5C9.94772 32.5 9.5 32.0523 9.5 31.5V21.5C9.5 20.9477 9.05228 20.5 8.5 20.5H4.5C3.94772 20.5 3.5 20.0523 3.5 19.5V12Z",
    stroke: "#637381"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 11C24.5 13.4853 22.933 15.5 21 15.5C19.067 15.5 17.5 13.4853 17.5 11C17.5 8.51472 19.067 6.5 21 6.5C22.933 6.5 24.5 8.51472 24.5 11Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7349 17.501H27.2849C28.5682 17.501 29.3682 16.1094 28.7266 15.001L22.4516 4.15938C21.8099 3.05104 20.2099 3.05104 19.5682 4.15938L13.2932 15.001C12.6516 16.1094 13.4516 17.501 14.7349 17.501ZM21.0099 11.6677C20.5516 11.6677 20.1766 11.2927 20.1766 10.8344V9.16771C20.1766 8.70937 20.5516 8.33437 21.0099 8.33437C21.4682 8.33437 21.8432 8.70937 21.8432 9.16771V10.8344C21.8432 11.2927 21.4682 11.6677 21.0099 11.6677ZM21.8432 15.001H20.1766V13.3344H21.8432V15.001Z",
    fill: "#FFAB00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaterTowerWarning);
export default __webpack_public_path__ + "static/media/water_tower_warning.588c48a5b6d9dafa9dec36e9f0060bdb.svg";
export { ForwardRef as ReactComponent };